import 'BomdisoftComponents/account/auth-buttons/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';

export type AuthButtonProps = {
  annotation?: string;
  annotationAction?: string;
  href: string;
  label: string;
  className?: string;
  testId?: string;
};

export const SignInButton = ({ annotation, annotationAction, className, href, label, testId = 'sign-in-button' }: AuthButtonProps) => (
  <a className={joinClasses('bomdisoft-auth-buttons-sign-in', className)} data-prodantix={annotation} data-prodantix-action={annotationAction} data-testid={testId} href={href}>
    {label}
  </a>
);

export const SignUpButton = ({ annotation, annotationAction, className, href, label, testId = 'sign-up-button' }: AuthButtonProps) => (
  <a className={joinClasses('bomdisoft-auth-buttons-sign-up', className)} data-prodantix={annotation} data-prodantix-action={annotationAction} data-testid={testId} href={href}>
    {label}
  </a>
);
